<div
	*ngFor="let toast of appService.toasts"
	class="toast-item"
	[class]="toast.classname"
	role="status"
	aria-live="polite"
	(click)="appService.remove(toast)"
>
	<ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
		<ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
	</ng-template>

	<ng-template #text>{{ toast.textOrTpl }}</ng-template>
</div>
